import React, { useState } from 'react'
import { Nav, NavLink, NavbarContainer, NavLinkIcons, NavItems, GitHubButton, MobileIcon, MobileMenu, MobileLink } from './NavbarStyledComponent'
import { FaBars, FaCode, FaHome, FaGraduationCap, FaBriefcase, FaFolderOpen } from 'react-icons/fa';
import { MdContactMail } from 'react-icons/md';
import { Bio } from '../../data/constants';
import { useTheme } from 'styled-components';

const Navbar = () => {

  const [isOpen, setIsOpen] = useState(false);
  const theme = useTheme();

  return (
    <Nav>
      <NavbarContainer>

        <MobileIcon>
          <FaBars onClick={() => setIsOpen(!isOpen)} />
        </MobileIcon>

        <NavItems>

          <NavLink href="#about">
            <NavLinkIcons><FaHome /></NavLinkIcons>
            <span>About</span>
          </NavLink>

          <NavLink href='#skills'>
            <NavLinkIcons><FaCode /></NavLinkIcons>
            <span>Skills</span>
          </NavLink>

          <NavLink href='#experience'>
            <NavLinkIcons><FaBriefcase /></NavLinkIcons>
            <span>Experience</span>
          </NavLink>

          <NavLink href='#projects'>
            <NavLinkIcons><FaFolderOpen /></NavLinkIcons>
            <span>Projects</span>
          </NavLink>

          <NavLink href='#education'>
            <NavLinkIcons><FaGraduationCap /></NavLinkIcons>
            <span>Education</span>
          </NavLink>

          <NavLink href='#contact'>
            <NavLinkIcons><MdContactMail /></NavLinkIcons>
            <span>Contact</span>
          </NavLink>

        </NavItems>


        {isOpen && (

          <MobileMenu isOpen={isOpen}>

            <MobileLink href="#about" onClick={() => setIsOpen(false)}>
              <FaHome /> About
            </MobileLink>

            <MobileLink href='#skills' onClick={() => setIsOpen(false)}>
              <FaCode /> Skills
            </MobileLink>

            <MobileLink href='#experience' onClick={() => setIsOpen(false)}>
              <FaBriefcase /> Experience
            </MobileLink>

            <MobileLink href='#projects' onClick={() => setIsOpen(false)}>
              <FaFolderOpen /> Projects
            </MobileLink>

            <MobileLink href='#education' onClick={() => setIsOpen(false)}>
              <FaGraduationCap /> Education
            </MobileLink>

            <MobileLink href='#contact' onClick={() => setIsOpen(false)}>
              <MdContactMail /> Contact
            </MobileLink>

            <GitHubButton
              style={{
                padding: '10px 16px',
                background: theme.primary,
                color: 'white',
                width: 'max-content'
              }}
              href={Bio.github}
              target="_blank"
            >
              Github Profile
            </GitHubButton>

          </MobileMenu>

        )}

      </NavbarContainer>
    </Nav>
  )
}

export default Navbar
